import { render } from "./AppModal.vue?vue&type=template&id=6a856ed9&scoped=true&ts=true&lang=pug"
import script from "./AppModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppModal.vue?vue&type=script&lang=ts&setup=true"

import "./AppModal.vue?vue&type=style&index=0&id=6a856ed9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a856ed9"]])

export default __exports__